import React from 'react';

const Breadcrumb = (props) => {
    return (
        <div className="tw-flex">
            {props.history.path.length > 1 && (

                props.history.path.map((item, index) => {
                    // Replace dashes with spaces and capitalize each word
                    let formattedItem = item
                        .split('-')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');

                    if (index == 0) {
                        formattedItem = "All Topics"
                    }

                    if (formattedItem == "Detroit Emobility") {
                        formattedItem = "eMobility"
                    }

                    const nonConditionalClasses = 'resource-library-menu-h2 tw-text-[14px] tw-font-normal tw-mb-0';
                    const conditionalClass = index != props.history.path.length - 1 ? 'tw-underline tw-cursor-pointer' : '';

                    return (
                        <React.Fragment key={index}>
                            <p className={`${nonConditionalClasses} ${conditionalClass}`} onClick={() => props.breadcrumbHandler(index)}>{formattedItem}</p>
                            {index < props.history.path.length - 1 && <p className={`tw-px-2 tw-mb-0`}>></p>}
                        </React.Fragment>
                    );
                })
            )}
        </div>
    );
}

export default Breadcrumb;